import { useState, useEffect } from "react";
import COP from '../../assets/currency/copu.png'
import USD from '../../assets/currency/usd.png'
const InvestmentCard = ({ currency, amount, days, earnings, loading, index }) => {
    return (
        <div className="w-80 bg-[#1a1b22] text-white p-4 rounded-xl shadow-lg">
            {/* Encabezado */}
            <div className="flex justify-between items-center mb-4">
                <div className="flex items-center gap-2">
                    <span className="text-lg">
                        <img src={currency === 'COP' ? COP : USD} width={20} height={20} alt="moneda" />
                        {currency}</span>
                </div>
                <span className="text-gray-400">{index}</span>
            </div>

            {/* Contenido */}
            {loading ? (
                <SkeletonLoader />
            ) : (
                <>
                    <p className="text-gray-400 text-sm">Monto invertido</p>
                    <h2 className="text-2xl font-semibold">{formatCurrency(amount)}</h2>
                    <p className="text-gray-400 text-sm mt-2">
                        Plazo <span className="text-white font-medium">{days} Días</span> | Ganancias{" "}
                        <span className="text-white font-medium">{earnings}% (EA)</span>
                    </p>
                </>
            )}
        </div>
    );
};

// Formatear número como moneda
const formatCurrency = (amount) => {
    return new Intl.NumberFormat("es-CO", {
        style: "currency",
        currency: "COP",
        minimumFractionDigits: 0,
    }).format(amount);
};

// Skeleton de carga
const SkeletonLoader = () => {
    return (
        <div className="animate-pulse">
            <div className="h-5 bg-gray-700 w-32 rounded mb-2"></div>
            <div className="h-8 bg-gray-700 w-48 rounded mb-3"></div>
            <div className="h-5 bg-gray-700 w-40 rounded"></div>
        </div>
    );
};

// Simulación de carga con estado

export default InvestmentCard;
